var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"ma-0 pa-0",attrs:{"id":"app"}},[_c('v-card',{staticClass:"container-all",attrs:{"elevation":"0","color":"#F7F7F7"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }